import { render } from "./ListeContribuable.vue?vue&type=template&id=048bd287"
import script from "./ListeContribuable.vue?vue&type=script&lang=js"
export * from "./ListeContribuable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Sekou A Sidibe\\Documents\\NTA TECH\\projets\\backoffice_operation_mouton\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__